import {
    IonCard,
    IonCardContent,
    IonCardTitle,
    IonCol,
    IonContent,
    IonPage,
    IonRow,
} from "@ionic/react";
import Header from "../../../../../components/Headers/Header";
import PageTitle from "../../../../../components/PageTitle/PageTitle";
import React from "react";
import CreateEventOrganizationForm from "../../../../../components/EventOrganization/CreateEventOrganizationForm";

const CreateEventOrganizationPage: React.FC = () => {
    
    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title="Create Organization" />
                <IonRow className="ion-justify-content-center">
                    <IonCol size="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Create Organization</IonCardTitle>
                            <IonCardContent>
                                <CreateEventOrganizationForm />
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default CreateEventOrganizationPage;